import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import pageStyles from "assets/jss/material-dashboard-pro-react/views/dashboardErrorPageStyles.jsx";

class DashboardErrorPage extends React.Component {

    render() {
        const {classes} = this.props;
        return (
            <div>
                <GridContainer>
                    <GridItem md={12}>
                        <h1 className={classes.title}>{this.props.errorTitle}</h1>
                        {this.props.errorSubTitle && (
                            <h2 className={classes.subTitle}>{this.props.errorSubTitle}</h2>
                        )}
                        {this.props.errorDescription && (
                            <h4 className={classes.description}>
                                {this.props.errorDescription}
                            </h4>
                        )}
                    </GridItem>
                </GridContainer>
            </div>
        );
    }

    static defaultProps = {
        classes: {},
    };
}

DashboardErrorPage.propTypes = {
    classes: PropTypes.object.isRequired,
    errorTitle: PropTypes.string.isRequired,
    errorSubTitle: PropTypes.string,
    errorDescription: PropTypes.string,
};

export default withStyles(pageStyles)(DashboardErrorPage);
